import { Suspense, useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { FileOnlyBtn } from 'widgets/HsptlzForm/ui';

import { SubmittedFormContainer } from './SubmittedFormContainer';

export const SubmittedFormPage = () => {
  const navigate = useNavigate();

  useLayoutEffect(() => {
    const viewport = document.querySelector('meta[name=viewport]');
    if (viewport) {
      viewport.setAttribute('content', 'width=595,maximum-scale=1.0,viewport-fit=cover');
    }
  }, []);

  return (
    <>
      <Suspense>
        <SubmittedFormContainer />
      </Suspense>
      <FileOnlyBtn
        text={'동의서 닫기'}
        handleClick={() => {
          navigate(-1);
        }}
        disabled={false}
        isValid={true}
      />
    </>
  );
};
